import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { isEmpty } from 'lodash';
import { AutoPromoList } from '../AutoPromoList';
export const ScrollableListViewTestId = 'serp-core-scrollablelistview-testid';
export const SerpCardTestId = 'serp-core-classified-card-testid';
export const SuggestionCardTestId = 'serp-core-suggestion-card-testid';
export const TopPositionCardTestId = 'serp-core-top-position-card-testid';
export const ScrollableListView = ({ listContent, Card, AdUnderstitial, AdSlot }) => {
    if (isEmpty(listContent))
        return null;
    let realIndex = -1;
    return (_jsx(Box, { overflow: "hidden", display: "flex", flexDirection: "column", height: "auto", rowGap: "spacing.24", marginBottom: "spacing.24", testId: ScrollableListViewTestId, children: listContent.map((content) => {
            if (content.type === 'topPositionClassified') {
                realIndex += 1;
                return (_jsx(Card, { testId: TopPositionCardTestId, id: content.classifiedId, index: realIndex, isCardXXL: true }, `list-top-position-${content.classifiedId}`));
            }
            if (content.type === 'auto_promo') {
                return _jsx(AutoPromoList, {}, "auto_promo_key");
            }
            if (content.type === 'classified') {
                realIndex += 1;
                return (_jsx(Card, { testId: SerpCardTestId, id: content.classifiedId, index: realIndex }, `list-classified-${content.classifiedId}`));
            }
            if (content.type === 'suggestion' && content.classifiedId) {
                realIndex += 1;
                return (_jsx(Card, { testId: SuggestionCardTestId, id: content.classifiedId, index: realIndex }, `suggestion-${content.classifiedId}`));
            }
            if (content.type === 'ad') {
                switch (content.adType) {
                    case 'understitial':
                        return _jsx(AdUnderstitial, {}, "list-ad-understitial");
                    case 'banner':
                    case 'inline1':
                    case 'inline2':
                    case 'inline3':
                    case 'inline4':
                    case 'inline5':
                    case 'inline6':
                        return _jsx(AdSlot, { slot: content.adType }, `list-ad-${content.adType}`);
                    default:
                }
            }
            return null;
        }) }));
};
